module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-contact-location"
  }, [_c('div', {
    staticClass: "custom-contact-location__hours-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.props.hours_group.title))]), _vm._l((_vm.props.hours_group.hours), function(hours) {
    return _c('div', {
      domProps: {
        "innerHTML": _vm._s(hours.day_time)
      }
    })
  })], 2), _c('div', {
    staticClass: "custom-contact-location__phone"
  }, [_vm._v(_vm._s(_vm.props.hours_group.phone))]), _c('div', {
    staticClass: "custom-contact-location__locations"
  }, _vm._l((_vm.props.locations), function(location) {
    return _c('div', {
      staticClass: "location"
    }, [_c('h5', [_vm._v(_vm._s(location.city))]), _c('div', {
      domProps: {
        "innerHTML": _vm._s(location.address)
      }
    })])
  }), 0), _c('div', {
    staticClass: "custom-contact-location__survey"
  }, [_c('div', {
    staticClass: "custom-contact-location__survey-button",
    on: {
      "click": function($event) {
        return _vm.showModal(4)
      }
    }
  }, [_vm._v("How Are We Doing?")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-413ebfc9","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-contact-locations/custom-contact-locations.pug
// module id = 642
// module chunks = 1